class DetailsDisclosure extends HTMLElement {
  constructor() {
    super();
    this.mainDetailsToggle = this.querySelector('details');
    this.content = this.mainDetailsToggle.querySelector('summary').nextElementSibling;

    this.mainDetailsToggle.addEventListener('focusout', this.onFocusOut.bind(this));
    this.mainDetailsToggle.addEventListener('toggle', this.onToggle.bind(this));
  }

  onFocusOut() {
    setTimeout(() => {
      if (!this.contains(document.activeElement)) this.close();
    });
  }

  onToggle() {
    if (!this.animations) this.animations = this.content.getAnimations();

    if (this.mainDetailsToggle.hasAttribute('open')) {
      this.animations.forEach((animation) => animation.play());
    } else {
      this.animations.forEach((animation) => animation.cancel());
    }
  }

  close() {
    this.mainDetailsToggle.removeAttribute('open');
    this.mainDetailsToggle.querySelector('summary').setAttribute('aria-expanded', false);
  }
}

customElements.define('details-disclosure', DetailsDisclosure);

class HeaderMenu extends DetailsDisclosure {
  static instances = [];

  constructor() {
    super();
    this.header = document.querySelector('.header-wrapper');
    this.summary = this.mainDetailsToggle.querySelector('summary');
    this.isDesktop = window.matchMedia('(min-width: 990px)').matches;
    this.hoverTimeout = null;
    
    // Register this instance
    HeaderMenu.instances.push(this);
    
    // Add hover functionality for desktop only
    if (this.isDesktop) {
      this.setupHoverEvents();
    }
    
    // Listen for window resize to update desktop state
    window.addEventListener('resize', () => {
      const wasDesktop = this.isDesktop;
      this.isDesktop = window.matchMedia('(min-width: 990px)').matches;
      
      if (this.isDesktop && !wasDesktop) {
        this.setupHoverEvents();
      } else if (!this.isDesktop && wasDesktop) {
        this.removeHoverEvents();
      }
    });
  }

  closeOtherMenus() {
    // Close all other header menus
    HeaderMenu.instances.forEach(instance => {
      if (instance !== this && instance.mainDetailsToggle.hasAttribute('open')) {
        instance.close();
        if (instance.hoverTimeout) {
          clearTimeout(instance.hoverTimeout);
          instance.hoverTimeout = null;
        }
      }
    });
  }

  setupHoverEvents() {
    // Open on hover
    this.mainDetailsToggle.addEventListener('mouseenter', () => {
      if (this.isDesktop) {
        // Clear any pending close timeout
        if (this.hoverTimeout) {
          clearTimeout(this.hoverTimeout);
          this.hoverTimeout = null;
        }
        
        // Close all other menus immediately
        this.closeOtherMenus();
        
        // Open this menu
        if (!this.mainDetailsToggle.hasAttribute('open')) {
          this.mainDetailsToggle.setAttribute('open', '');
          this.summary.setAttribute('aria-expanded', 'true');
          this.onToggle();
        }
      }
    });

    // Close when mouse leaves
    this.mainDetailsToggle.addEventListener('mouseleave', () => {
      if (this.isDesktop && this.mainDetailsToggle.hasAttribute('open')) {
        // Clear any existing timeout
        if (this.hoverTimeout) {
          clearTimeout(this.hoverTimeout);
        }
        // Small delay to allow moving to submenu
        this.hoverTimeout = setTimeout(() => {
          // Double check we're not hovering before closing
          if (!this.mainDetailsToggle.matches(':hover')) {
            this.close();
          }
        }, 100);
      }
    });

    // Keep open when hovering over submenu
    const submenu = this.mainDetailsToggle.querySelector('.header__submenu');
    if (submenu) {
      submenu.addEventListener('mouseenter', () => {
        // Clear close timeout when entering submenu
        if (this.hoverTimeout) {
          clearTimeout(this.hoverTimeout);
          this.hoverTimeout = null;
        }
      });

      submenu.addEventListener('mouseleave', () => {
        if (this.isDesktop) {
          // Clear any existing timeout
          if (this.hoverTimeout) {
            clearTimeout(this.hoverTimeout);
          }
          // Close after leaving submenu
          this.hoverTimeout = setTimeout(() => {
            this.close();
          }, 100);
        }
      });
    }
  }

  removeHoverEvents() {
    // Remove hover event listeners if needed
    // The events will naturally not work on mobile due to isDesktop check
  }

  close() {
    // Clear any pending timeout
    if (this.hoverTimeout) {
      clearTimeout(this.hoverTimeout);
      this.hoverTimeout = null;
    }
    super.close();
  }

  onToggle() {
    if (!this.header) return;
    this.header.preventHide = this.mainDetailsToggle.open;

    if (document.documentElement.style.getPropertyValue('--header-bottom-position-desktop') !== '') return;
    document.documentElement.style.setProperty(
      '--header-bottom-position-desktop',
      `${Math.floor(this.header.getBoundingClientRect().bottom)}px`
    );
  }
}

customElements.define('header-menu', HeaderMenu);
